<template>
  <v-container fluid class="purchasereceipt-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-tabs color="primary">
          <v-tab :href="`#tab-receipt`" class="mr-5">
            <v-icon class="mr-3">mdi-text-box-outline</v-icon>
            Receipt
          </v-tab>
          <v-tab class="mr-5" :href="`#tab-items`" >
            <v-icon class="mr-3">mdi-drawing-box</v-icon>
            Items
          </v-tab>
          <v-tab-item :value="'tab-receipt'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Purchase Receipt</p>
                      <v-select
                        readonly
                        class="mb-4"
                        :items="purchasereceipttype"
                        v-model="edit_receipt.purchasereceipttype"
                        v-on:change="onChangeReceipt($event, 'purchasereceipttype')"
                        v-bind:error="errorindex == 0"
                        outlined
                        dense
                        placeholder="Type"
                        persistent-hint
                        single-line
                        hint="Please choose the receipt type"
                      >
                      </v-select>
                      <v-menu
                        :readonly="isNotEditable"
                        ref="menu_purchasereceiptdate"
                        v-model="menu_purchasereceiptdate"
                        :close-on-content-click="false"
                        :return-value.sync="purchasereceiptdate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            :readonly="isNotEditable"
                            outlined
                            dense
                            v-model="purchasereceiptdate"
                            label="Receipt Date"
                            v-bind="attrs"
                            v-bind:value="purchasereceiptdate"
                            v-on:change="
                              onChangeReceipt($event, 'purchasereceiptdate')
                            "
                            v-bind:error="errorindex == 1"
                            v-on="on"
                            single-line
                            hint="Please choose the receipt date"
                            persistent-hint
                          >
                            ></v-text-field
                          >
                        </template>
                        <v-date-picker
                          :readonly="isNotEditable"
                          v-model="purchasereceiptdate"
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menu_purchasereceiptdate = false"
                          >
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="onChangeReceipt(purchasereceiptdate,'purchasereceiptdate'); $refs.menu_purchasereceiptdate.save(purchasereceiptdate);"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        :readonly="isNotEditable"
                        class="mb-4"
                        :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                        v-model="edit_receipt.locationid"
                        v-on:change="onChangeReceipt($event, 'locationid')"
                        outlined
                        dense
                        placeholder="Location"
                        persistent-hint
                        single-line hint="Please choose the location">
                      </v-select>
                      <v-text-field
                        :readonly="isNotEditable"
                        class="mb-4"
                        v-model="edit_receipt.refnum"
                        v-on:change="onChangeReceipt($event, 'refnum')"
                        outlined
                        dense
                        placeholder="Ref Num"
                        persistent-hint
                        single-line hint="Enter reference or description">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>

                      <v-select
                        class="mb-4"
                        :items="['New', 'Pending', 'Approved', 'Completed']"
                        v-model="edit_receipt.purchasereceiptstatus"
                        v-on:change="onChangeReceipt($event, 'purchasereceiptstatus')"
                        outlined
                        dense
                        placeholder="Status"
                        persistent-hint
                        single-line
                        hint="Please choose the status"
                      >
                      </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/purchasereceipt/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Cancel
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn
                        :loading="isReceiving"
                        class="button-shadow"
                        color="primary"
                        @click="updatePurchaseReceipt()"
                      >
                        Save
                      </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-items'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row>
                  <v-col md="6">
                    <p class="text-h5">Items</p>
                  </v-col>
                  <v-col cols="6" sm="6" md="6" lg="6" class="d-flex flex-end justify-md-end overflow-auto" align="right">
                    <v-btn
                      class="button-shadow mr-1"
                        to="/purchasereceipt/list"
                        replace
                        color="primary"
                      >
                        Done
                    </v-btn>
                  </v-col>
                  </v-row>
                  <v-data-table
                        :headers="header_items"
                        :items="transactions"
                        :items-per-page="100"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeleteTransaction" width="500">
                            <v-card>
                              <v-card-title> Delete this Item? </v-card-title>
                              <v-card-text>
                                {{ delete_transaction.transname }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeleteTransaction = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deleteTransaction(delete_transaction)"
                                  >Delete</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemimage="{ item }">
                          <v-img
                            v-bind:lazy-src="item.itemimage"
                            min-width="50"
                            max-width="100"
                            v-bind:src="item.itemimage"
                          ></v-img>
                        </template>
                        <template v-slot:item.transtype="{ item }">
                          {{ item.transtype }} {{ item.transnum }}
                        </template>
                        <template v-slot:item.receiveQty="{ item }">
                          {{ item.receiveQty.toFixed(2) }}
                        </template>
                        <template v-slot:item.transdate="{ item }">
                          {{ item.transdate!=null ? new Date(item.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) : '' }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-btn
                            icon
                            color="primary"
                            @click="updateTransactionDialog(item)"
                          >
                            <v-icon>mdi-pencil-outline</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deleteTransactionDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <div class="text-center">
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="700px"
        max-width="700px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Transaction</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    readonly
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {
                      return {text: x.brandname, value: x._id};
                    })"
                    v-model="edit_transaction.brandid"
                    v-bind:error="errorindex == 2"
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="8">
                  <v-select
                    readonly
                    class="mb-4"
                    :items="items.filter(item=>item.brandid == edit_transaction.brandid).map(x => {
                      return {text: x.itemname, value: x._id};
                      })"
                    v-model="edit_transaction.itemid"
                    v-bind:error="errorindex == 0"
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.itemquantity"
                    class="mb-4"
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    single-line hint="Ordered Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.itemcost"
                    v-on:change="onChangeTransaction($event, 'itemcost')"
                    class="mb-4"
                    dense
                    placeholder="Cost"
                    persistent-hint
                    single-line hint="Cost">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    type="number"
                    v-model="edit_transaction.receiveQty"
                    v-on:change="onChangeTransaction($event, 'receiveQty')"
                    class="mb-4"
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Receive Quantity">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={}; change_transaction={};"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
        v-model="isUploadFile"
        persistent
        max-width="600px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Upload File</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                <v-file-input label="File input" v-model="upload.file" v-on:change="onChangeFile" accept=".pdf" />
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    v-model="upload.filename"
                    label="File Name"
                    required
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isUploadFile = false; upload.file=null; upload.filename=''"
            >
              Close
            </v-btn>
            <v-btn
              :disabled="upload.file==null"
              color="blue darken-1"
              text
              @click="uploadFile"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { formatStdDate } from '@/mixins/date';
import router from "@/Routes";

export default {
  data() {
    return {
      header_items: [
        { text: 'Image', value: 'itemimage' , width: '7%'},
        { text: 'Name', value: 'itemname' },
        { text: 'Cost', value: 'itemcost', width: '10%'},
        { text: 'Order Qty', value: 'itemquantity', width: '10%'},
        { text: 'Received', value: 'receiveQty', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false, width: '10%' },
      ],

      initvalue: {},
      change_receipt: {},
      edit_receipt: {},
      edit_transaction: {},
      change_transaction: {},
      new_transaction: {},
      delete_transaction: {},

      upload: {filename: null,file: null},
      files: [],
      purchasereceipttype: ["Purchase Receipt"],
      transactions: [],
      footer: {'items-per-page-options': [500, 1000, 5000]},


      purchasereceiptdate: null,
      menu_purchasereceiptdate: false,
      isEditTransaction: false,
      isAddTransaction: false,
      isUploadFile: false,
      isDeleteFile: false,
      isDeleteTransaction: false,    
      errorindex: undefined,
    };
  },
  computed: {
    ...mapState("Brand", ["brands"]),
    ...mapState("PurchaseReceipt", ["isReceiving"]),
    ...mapState("Department", ["departments"]),
    ...mapState("Item", ["items"]),
    ...mapState("Location", ["locations"]),
    ...mapState("User", ["users"]),
    ...mapState("Vendor", ["vendors"]),
    isNotEditable(){
      let result = ['New','Credit','Partial','Pending','Audit','Void'].indexOf(this.initvalue.purchasereceiptstatus) == -1;
      return result;
    },
    isEditable(){
      let result = ['New','Partial', 'Audit', 'Void'].indexOf(this.initvalue.purchasereceiptstatus) >= 0;
      return result;
    }
  },
  methods: {
    ...mapActions("Brand", ["getBrandsRequest"]),
    ...mapActions("PurchaseReceipt", ["deletePurchaseReceiptTransactionRequest", "getPurchaseReceiptRequest", "insertPurchaseReceiptTransactionRequest", "updatePurchaseReceiptRequest", "updatePurchaseReceiptTransactionRequest"]),
    ...mapActions("Department", ["getDepartmentsRequest"]),
    ...mapActions("File", ["insertRouteFile", "deleteFileRequest"]),
    ...mapActions("Item", ["getItemsRequest"]),
    ...mapActions("Location", ["getLocationsRequest"]),
    ...mapActions("User", ["getUsersRequest"]),
    checkError() {
      if (!this.accessname) {
        this.errorindex = 0;
        return false;
      }
      if (!this.accesspath) {
        this.errorindex = 1;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkTransaction(){
      if(!this.new_transaction.accountid){
        this.haserrors = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.new_transaction.itemdesc){
        this.haserrors = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.new_transaction.itemamount){
        this.haserrors = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    clearTransaction() {
      this.edit_transaction = {};
      this.new_transaction = {};
    },
    deleteTransactionDialog(item) {
      this.isDeleteTransaction = true;
      this.delete_transaction = {_id: item._id, transname: item.transname};
    },
    async deleteTransaction(payload) {
      this.isDeleteTransaction = false;
      console.log(payload)
      let response = await this.deletePurchaseReceiptTransactionRequest(payload);
      let index = this.transactions.findIndex((trans) => trans._id == response._id);
      this.transactions.splice(index, 1);
      this.getPurchaseReceiptRequest(this.initvalue._id);
    },
    async insertTransaction() {
      if(!this.checkTransaction()) return;
      let payload = Object.assign({depositid: this.initvalue._id}, this.new_transaction);
      console.log(this.new_transaction)
      let response = await this.insertPurchaseReceiptTransactionRequest(payload);
      this.transactions.push(response);
      this.getPurchaseReceiptRequest(this.initvalue._id);
      this.clearTransaction();
      this.isAddTransaction = false;
    },

    onChangeFile(file) {
      if (!file) this.upload.file = null;
      else this.upload.file = file;
    },
    onChangeReceipt(value, field) {
      this.change_receipt[field] = value;
    },
    onChangeTransaction(value, field){
      this.change_transaction[field] = value;
    },
    async updatePurchaseReceipt() {
      this.change_receipt._id = this.initvalue._id;
      await this.updatePurchaseReceiptRequest(this.change_receipt);
      router.push("/purchasereceipt/list");
    },
    updateTransactionDialog(item){
      let find = this.items.find(x=>x._id==item.itemid);
      let edit = {
        _id: item._id,
        brandid: find.brandid,
        itemid: item.itemid,
        itemcost: item.itemcost,
        itemquantity: item.itemquantity,
        receiveQty: item.receiveQty,
      }
      this.edit_transaction = Object.assign({}, edit);
      this.isEditTransaction = true;
    },
    async updateTransaction() {
      this.isEditTransaction = false;
      this.change_transaction._id = this.edit_transaction._id;
      console.log('update',this.change_transaction)
      let response = await this.updatePurchaseReceiptTransactionRequest(this.change_transaction);
      let index = this.transactions.findIndex((x) => x._id == response._id);
      this.transactions.splice(index, 1, response);
      this.edit_transaction = {};
      this.getPurchaseReceiptRequest(this.initvalue._id);
    },
    async uploadFile(){
      this.isUploadFile = false;
      this.upload.id = this.initvalue._id;
      this.upload.route = 'deposit';
      let file = await this.insertRouteFile(this.upload);
      this.files.push(file);
      this.upload = {filename: null,file: null};
      this.getPurchaseReceiptRequest(this.initvalue._id);
    },
  },

  async created() {
    this.initvalue = this.$route.params;
    if (!this.initvalue._id) this.$router.push({ name: "PurchaseReceiptList" });
    this.edit_receipt = Object.assign({}, this.initvalue);
    this.purchasereceiptdate = formatStdDate(this.initvalue.purchasereceiptdate);

    if (this.brands.length==0) await this.getBrandsRequest();
    if (this.items.length==0) await this.getItemsRequest();
    if (this.locations.length==0) await this.getLocationsRequest();
    if (this.users.length==0) await this.getUsersRequest();

    this.files = this.initvalue.files;
    console.log(this.initvalue)
    this.transactions = Object.assign([], this.initvalue.transactions);
    console.log(this.transactions)
  },
};
</script>

<style src="./Edit.scss" lang="scss"></style>
